import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " We are committed to not only creating best-in-class digital products, but also to maximizing our employee experience and their personal development. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-12 md:mt-16 font-bold font-mabry-pro text-lg md:text-2xl" }, " I'm a... ", -1)
const _hoisted_3 = { class: "flex flex-col md:flex-row justify-between mt-16 md:mt-20" }
const _hoisted_4 = {
  key: 1,
  class: "flex justify-center items-center flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_AOS = _resolveComponent("AOS")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_Input = _resolveComponent("Input")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkmark = _resolveComponent("Checkmark")!
  const _component_Container = _resolveComponent("Container")!
  const _component_ThemeChanger = _resolveComponent("ThemeChanger")!
  const _component_MetaInfo = _resolveComponent("MetaInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ThemeChanger, {
      to: _ctx.Theme.Purple
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Container, {
          fluid: "",
          class: "pt-32 md:pt-48 pb-24"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PageHeader, { header: "Join the DC development team" }),
            _createVNode(_component_Grid, { class: "mt-8" }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { span: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AOS, { order: "3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Paragraph, { class: "text-gray-600" }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_Grid, {
              columns: [ 2, 6 ],
              class: "mt-12 md:mt-24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  span: [ 2, 4 ],
                  push: [ 0, 1 ]
                }, {
                  default: _withCtx(() => [
                    (!_ctx.formSubmitted)
                      ? (_openBlock(), _createElementBlock("form", {
                          key: 0,
                          class: "w-full",
                          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                        }, [
                          _createVNode(_component_Input, {
                            type: _ctx.InputType.Text,
                            validation: _ctx.validation.name,
                            name: "name",
                            placeholder: _ctx.lang.name
                          }, null, 8, ["type", "validation", "placeholder"]),
                          _createVNode(_component_Input, {
                            type: _ctx.InputType.Email,
                            validation: _ctx.validation.email,
                            name: "email",
                            placeholder: _ctx.lang.email
                          }, null, 8, ["type", "validation", "placeholder"]),
                          _createVNode(_component_Input, {
                            type: _ctx.InputType.Text,
                            validation: _ctx.validation.githubUsername,
                            name: "githubUsername",
                            placeholder: "Github username"
                          }, null, 8, ["type", "validation"]),
                          _hoisted_2,
                          _createVNode(_component_CheckboxInput, {
                            class: "mt-8",
                            checked: _ctx.selectedRole === _ctx.RoleType.VueJs,
                            title: "Front-end developer (Vue.js)",
                            onChecked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedRole = _ctx.RoleType.VueJs))
                          }, null, 8, ["checked"]),
                          _createVNode(_component_CheckboxInput, {
                            class: "mt-8",
                            checked: _ctx.selectedRole === _ctx.RoleType.Flutter,
                            title: "Flutter developer",
                            onChecked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedRole = _ctx.RoleType.Flutter))
                          }, null, 8, ["checked"]),
                          _createVNode(_component_CheckboxInput, {
                            class: "mt-8",
                            checked: _ctx.selectedRole === _ctx.RoleType.Laravel,
                            title: "Laravel developer",
                            onChecked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedRole = _ctx.RoleType.Laravel))
                          }, null, 8, ["checked"]),
                          _createVNode(_component_CheckboxInput, {
                            class: "mt-8",
                            checked: _ctx.selectedRole === _ctx.RoleType.MiniProgram,
                            title: "Mini Program developer",
                            onChecked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedRole = _ctx.RoleType.MiniProgram))
                          }, null, 8, ["checked"]),
                          _createVNode(_component_CheckboxInput, {
                            class: "mt-8",
                            checked: _ctx.selectedRole === _ctx.RoleType.ProjectManager,
                            title: "Project manager",
                            onChecked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedRole = _ctx.RoleType.ProjectManager))
                          }, null, 8, ["checked"]),
                          _createVNode(_component_Input, {
                            class: "mt-12 md:mt-16",
                            type: _ctx.InputType.TextArea,
                            validation: _ctx.validation.yourDetails,
                            name: "yourDetails",
                            placeholder: "Tell us about yourself..."
                          }, null, 8, ["type", "validation"]),
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_FileUpload, {
                              text: "Upload a resume if you have it...",
                              onSelected: _ctx.setResume
                            }, null, 8, ["onSelected"]),
                            _createVNode(_component_Button, {
                              class: "mt-8 md:mt-0",
                              "is-loading": _ctx.formLoading,
                              large: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formLoading ? _ctx.lang.submitting : _ctx.lang.submit), 1)
                              ]),
                              _: 1
                            }, 8, ["is-loading"])
                          ])
                        ], 32))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_Checkmark),
                          _createVNode(_component_Paragraph, { class: "text-green-200 mt-10 w-full md:w-3/6 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.lang.message_sent), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Button, {
                            class: "mt-12",
                            large: "",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmitted = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.lang.sent_button_text), 1)
                            ]),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"]),
    (_ctx.lang.seo)
      ? (_openBlock(), _createBlock(_component_MetaInfo, {
          key: 0,
          seo: _ctx.lang.seo,
          "structured-data": _ctx.lang.seo_structured_data
        }, null, 8, ["seo", "structured-data"]))
      : _createCommentVNode("", true)
  ], 64))
}